import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  resetTopMargin: {
    marginTop: [0, '!important']
  },
  multiFieldItem: {
    '&:last-child': {
      marginBottom: 16
    }
  }
})

export default useStyles
